module.exports = __webpack_public_path__ + "img/construct.844c2dd4.svg";